import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import TablePagination from '@material-ui/core/TablePagination';

const DataTablePagination = ({ count, onChangePage, onChangeRowsPerPage, page, rowsPerPage, rowsPerPageOptions = [5, 10, 25] }) => {
  const intl = useIntl();

  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      component="div"
      count={count}
      rowsPerPage={rowsPerPageOptions.indexOf(rowsPerPage) >= 0 ? rowsPerPage : rowsPerPageOptions[0]}
      page={page}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      labelRowsPerPage={intl.formatMessage({
        id: 'app.dataTable.pagination.rowsPerPage',
        defaultMessage: 'app.dataTable.pagination.rowsPerPage',
      })}
      labelDisplayedRows={({ from, to, count: rowCount }) => {
        return <FormattedMessage id="app.dataTable.pagination.summary" values={{ from, to, count: rowCount }} />;
      }}
    />
  );
};

DataTablePagination.propTypes = {
  children: PropTypes.node,
  count: PropTypes.number,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
};

export default DataTablePagination;
